import { wrapScaledHtml, mmToCssPx } from './idCardScale';

const IN_TO_MM = 25.4;

function cardPageMm(size) {
  return {
    wMm: size.widthIn * IN_TO_MM,
    hMm: size.heightIn * IN_TO_MM,
  };
}

/**
 * One card face page — full template scaled to fit print area, centered.
 */
export function buildSingleCardPageHtml(html, size, { pageBreakAfter = true } = {}) {
  const { wMm, hMm } = cardPageMm(size);
  const targetW = mmToCssPx(wMm);
  const targetH = mmToCssPx(hMm);
  const cardHtml = wrapScaledHtml(html, size.widthPx, size.heightPx, targetW, targetH, { center: true });
  const breakStyle = pageBreakAfter ? 'page-break-after:always;' : 'page-break-after:auto;';

  return `<div class="id-card-page" style="width:${wMm}mm;height:${hMm}mm;display:flex;align-items:center;justify-content:center;background:#fff;${breakStyle}overflow:hidden;">
    ${cardHtml}
  </div>`;
}

/**
 * Full single-student document (front + back) — shared by preview iframe, print, PDF capture.
 */
export function buildSingleCardDocumentHtml({ frontHtml, backHtml, size, title = 'ID Card' }) {
  const { wMm, hMm } = cardPageMm(size);
  const frontPage = buildSingleCardPageHtml(frontHtml, size, { pageBreakAfter: true });
  const backPage = buildSingleCardPageHtml(backHtml, size, { pageBreakAfter: false });

  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title><style>
    @page { size: ${wMm}mm ${hMm}mm; margin: 0; }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { margin: 0; padding: 0; background: #fff; }
    .id-card-document { background: #fff; }
    .card-scaled-inner { display: block; }
  </style></head><body><div class="id-card-document">${frontPage}${backPage}</div></body></html>`;
}

export { mmToCssPx } from './idCardScale';
